import React, { Component } from 'react';

import Select from '../../../../../Shared/React/js/components/Select';

export default class TabletSelector extends Component {
    constructor(props) {
        super(props);

        this.showTabletPicker = this.showTabletPicker.bind(this);
        this.removeTablet = this.removeTablet.bind(this);
        this.setSimOnly = this.setSimOnly.bind(this);
        this.showSpecs = this.showSpecs.bind(this);
        this.showGallery = this.showGallery.bind(this);
        this.upfrontCostChanged = this.upfrontCostChanged.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        return (
            nextProps.criteria.tabletShortUrl !== this.props.criteria.tabletShortUrl ||
            nextProps.criteria.includeSimOnly !== this.props.criteria.includeSimOnly ||
            nextProps.criteria.simType !== this.props.criteria.simType ||
            nextProps.criteria.maximumTabletUpfrontCost !== this.props.criteria.maximumTabletUpfrontCost
        );
    }

    showTabletPicker() {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var that = this;
        WhistleOut.Tablets.showTabletPicker(false, function (selectedTablet) {
            if (selectedTablet.id === -1) {
                that.props.actions.changeTablet(selectedTablet.shortUrl, true, selectedTablet.simType);
            } else {
                that.props.actions.changeTablet(selectedTablet.shortUrl);
            }
        });
    }

    upfrontCostChanged(value) {
        this.props.actions.changeUpfrontCost(value === '-1' ? null : value);
    }

    removeTablet() {
        this.props.actions.changeTablet(null);
    }

    showSpecs() {
        WhistleOut.showTabletSpecs(this.props.criteria.tabletShortUrl);
    }

    showGallery() {
        WhistleOut.showTabletGallery(this.props.criteria.tabletShortUrl);
    }

    setSimOnly(e) {
        const simType = e.currentTarget.getAttribute('data-sim-type');
        this.props.actions.changeTablet(null, true, simType);
    }

    getTabletName() {
        const shortUrl = this.props.criteria.tabletShortUrl;
        const simOnly = this.props.criteria.includeSimOnly;
        const simType = this.props.criteria.simType;
        const hasTablet = shortUrl && shortUrl.length > 0;

        if (!hasTablet && !simOnly) {
            return this.props.resources.noTabletSelected;
        } else if (!hasTablet && simOnly && !simType) {
            return this.props.resources.simOnly;
        } else if (!hasTablet && simOnly && simType) {
            return `${this.props.simTypes[simType]}`;
        }

        const currentTablet = this.props.tablets.find(t => t.shortUrl === shortUrl);
        return currentTablet.name;
    }
    getTabletAltText() {
        var tabletName = this.getTabletName();

        return tabletName === this.props.resources.noTabletSelected
            ? this.props.resources.noTabletSelectedAltText
            : tabletName === this.props.resources.simOnly
              ? this.props.resources.simOnlyAltText
              : tabletName;
    }

    getTabletImages() {
        var shortUrl = this.props.criteria.tabletShortUrl;
        const hasTablet = shortUrl && shortUrl.length > 0;

        if (!hasTablet) {
            if (this.props.criteria.includeSimOnly) {
                return this.props.byoTabletImageUrl;
            }

            return this.props.addTabletImageUrl;
        }

        const currentTablet = this.props.tablets.find(t => t.shortUrl === shortUrl);
        return currentTablet.imageUrl;
    }

    render() {
        const tabletSelected = this.props.criteria.tabletShortUrl && this.props.criteria.tabletShortUrl.length > 0;
        const tabletPickerLinkText = tabletSelected
            ? this.props.resources.changeTablet
            : this.props.resources.selectATablet;

        const maxUpfrontValues = this.props.maxUpfrontValues;
        const upfrontDropdownValues = Object.keys(maxUpfrontValues).map(p => {
            const text = maxUpfrontValues[p];
            return {
                key: p,
                title: text,
                value: text
            };
        });

        const maxUpfront = this.props.criteria.maximumTabletUpfrontCost;

        return (
            <React.Fragment>
                <div className="img-cropped visible-xs pad-b-3 bor-b-1">
                    <a href="javascript:void(0)" onClick={this.showTabletPicker}>
                        <img
                            alt={this.getTabletAltText()}
                            className="img-cropped__img img-feature-img"
                            src={this.getTabletImages().medium}
                        />{' '}
                        {this.getTabletName()}
                    </a>
                </div>
                <div className="img-cropped--large hidden-xs">
                    <a href="javascript:void(0)" onClick={this.showTabletPicker}>
                        <img
                            alt={this.getTabletAltText()}
                            className="img-cropped__img img-feature-img"
                            src={this.getTabletImages().large}
                        />
                    </a>
                    <div className="text-muted"> {this.props.resources.selectedTablet} </div>
                    <div className="font-5 font-4-md">
                        {' '}
                        <strong>{this.getTabletName()}</strong>{' '}
                    </div>
                    <div className="dropdown mar-y-2">
                        <div className="btn-group bootstrap-select fit-width">
                            <button
                                className="btn btn-default font-3 pad-y-1 dropdown-toggle"
                                id="tabletSelectorDropdown"
                                type="button"
                                data-toggle="dropdown"
                                aria-expanded="true"
                            >
                                <span className="filter-option pull-left needsclick">
                                    {this.props.resources.tabletActions}&nbsp;
                                </span>
                                <span className="caret" />
                            </button>
                            <ul className="dropdown-menu" role="menu" aria-labelledby="tabletSelectorDropdown">
                                <li>
                                    <a href="javascript:void(0)" onClick={this.showTabletPicker}>
                                        {tabletPickerLinkText}
                                    </a>
                                </li>
                                {(() => {
                                    if (tabletSelected) {
                                        return (
                                            <li>
                                                <a href="javascript:void(0)" onClick={this.removeTablet}>
                                                    {this.props.resources.removeTablet}
                                                </a>
                                            </li>
                                        );
                                    }
                                    return null;
                                })()}
                                {(() => {
                                    if (tabletSelected) {
                                        return (
                                            <li>
                                                <a href="javascript:void(0)" onClick={this.showSpecs}>
                                                    {this.props.resources.specs}
                                                </a>
                                            </li>
                                        );
                                    }
                                    return null;
                                })()}
                                {(() => {
                                    if (tabletSelected) {
                                        return (
                                            <li>
                                                <a href="javascript:void(0)" onClick={this.showGallery}>
                                                    {this.props.resources.gallery}
                                                </a>
                                            </li>
                                        );
                                    }
                                    return null;
                                })()}
                                {this.props.simTypes && this.props.simTypes.length > 0 ? (
                                    <React.Fragment>
                                        <li role="separator" className="divider"></li>
                                        {Object.keys(this.props.simTypes).map(key => {
                                            return (
                                                <li key={`simType-${key}`}>
                                                    <a
                                                        href="javascript:void(0)"
                                                        data-sim-type={key}
                                                        onClick={this.setSimOnly}
                                                    >
                                                        {this.props.simTypes[key]}
                                                    </a>
                                                </li>
                                            );
                                        })}
                                    </React.Fragment>
                                ) : null}
                                {(() => {
                                    if (!this.props.criteria.includeSimOnly && !this.props.simTypes) {
                                        return (
                                            <li>
                                                <a href="javascript:void(0)" onClick={this.setSimOnly}>
                                                    {this.props.resources.swithToByo}
                                                </a>
                                            </li>
                                        );
                                    } else if (this.props.criteria.includeSimOnly) {
                                        return (
                                            <li>
                                                <a href="javascript:void(0)" onClick={this.removeTablet}>
                                                    {this.props.resources.removeByo}
                                                </a>
                                            </li>
                                        );
                                    }
                                })()}
                            </ul>
                        </div>
                    </div>
                    {this.props.showMaxUpfront && tabletSelected ? (
                        <div className="dropdown mar-y-2">
                            <Select
                                key="tablet-upfront"
                                dataStyle="btn-default font-3 pad-y-1"
                                optionGroups={[{ values: upfrontDropdownValues }]}
                                dataWidth="fit"
                                onChange={this.upfrontCostChanged}
                                selectedValues={maxUpfront || maxUpfront === 0 ? maxUpfront : -1}
                            />
                        </div>
                    ) : null}
                </div>
            </React.Fragment>
        );
    }
}
